/**
 * Clientes HTTP pre-configurados para cada módulo
 * Cada cliente usa la API key específica de su módulo
 */

import { HttpClient } from './client';
import { API_KEYS, type ModuleName } from '@/config/apiKeys';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api';

/**
 * Factory function para crear un cliente HTTP para un módulo específico
 */
export function createModuleClient(module: ModuleName): HttpClient {
    return new HttpClient(API_BASE_URL, API_KEYS[module]);
}

// Clientes pre-configurados para cada módulo
export const formsClient = createModuleClient('forms');
export const authClient = createModuleClient('auth');
export const admissionsClient = createModuleClient('admissions');
export const enrollmentsClient = createModuleClient('enrollments');
export const surveysClient = createModuleClient('surveys');
